<template>
  <v-row justify="center" class="ma-n1 pa-3">
    <v-col
      class="news-container pa-1"
      cols="12"
      sm="6"
      md="6"
      lg="4"
      xl="3"
      v-for="(nf, index) in $store.state.newsFeeds"
      :key="index"
    >
      <v-card>
        <v-img v-if="getNewsFeedImageSrc(nf) != null" :src="getNewsFeedImageSrc(nf)"> </v-img>
        <v-card-title v-if="getNewsFeedTitle(nf) != ''">{{ getNewsFeedTitle(nf) }}</v-card-title>

        <v-card-subtitle class="mb-2" v-if="getNewsFeedContent(nf) != ''" v-html="getNewsFeedContent(nf)">
        </v-card-subtitle>

        <!--             <v-card-actions>
              <div>Posted On : {{ toLocaleString(nf.PostedOn) }}</div>
            </v-card-actions> -->
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  methods: {
    getNewsFeedImageSrc(nf) {
      let url = null;
      if (!this.isEmptyObject(nf.Image)) {
        if (nf.Image.AltUrl != "") url = nf.Image.AltUrl;
        else if (nf.Image.DownloadPath != "") url = nf.Image.DownloadPath;
      }

      return url;
    },

    getNewsFeedTitle(nf) {
      if (nf == null) return "";
      else {
        let title = "";
        if (this.$store.state.descrIndex == 1) title = nf.title1;
        else if (this.$store.state.descrIndex == 2) title = nf.title2;
        else title = nf.title;
        if (title == null) title = "";
        return title.trim();
      }
    },

    getNewsFeedContent(nf) {
      if (nf == null) return "";
      else {
        let content = "";
        if (this.$store.state.descrIndex == 1) content = nf.content1;
        else if (this.$store.state.descrIndex == 2) content = nf.content2;
        else content = nf.content;
        if (content == null) content = "";
        return content.trim();
      }
    },
  },
};
</script>

<style lang="scss">
.news-container {
  .v-card {
    min-height: 150px;
  }

  .v-card__title {
    word-break: normal !important;
  }
  .v-card__actions {
    div {
      font-size: 0.8em;
      position: absolute;
      bottom: 0px;
      padding: 8px 16px;

      text-align: right;
      width: 100%;
      color: grey;
      border-top: solid 1px var(--v-background-base);
    }
  }

  padding: 0px;
  padding-bottom: 8px;
}
</style>
